module.exports = __webpack_public_path__ + "img/seamstress.209ed80b.png";